import React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

import { ROUTES } from 'shared/routes/constants';
import PaymentPendingUI from 'uicontainers/apps/survey/PaymentPending';
import PaymentPendingRefresh from 'uicontainers/apps/survey_refresh/PaymentPending';

export const PaymentPending = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const template = queryParams.get('survey_template');
  return (
    <>
      <Switch>
        <Route
          path={ROUTES.SURVEY.PATHS.PAYMENT_PENDING}
          component={
            template === 'SURVEY_2025' || template === 'CONSULTATIONS_2025'
              ? PaymentPendingRefresh
              : PaymentPendingUI
          }
        />
      </Switch>
    </>
  );
};

export default PaymentPending;
